import { useStore } from 'react-redux'
import { Actions as ModalActions } from 'actions/shared/modal'

type HookFunctions = {
  showModal: (name: string) => void
  showModalWithData: (name: string, data?: Record<string, any>) => void
  closeModal: () => void
}

const useModal = (): HookFunctions => {
  const store = useStore()

  const showModal = (name: string): void => {
    store.dispatch(ModalActions.OPEN_MODAL(name))
  }

  const showModalWithData = (name: string, data: Record<string, any> = {}): void => {
    store.dispatch(ModalActions.OPEN_MODAL_WITH_DATA({ name, data }))
  }

  const closeModal = (): void => {
    store.dispatch(ModalActions.CLOSE_MODAL())
  }

  return {
    showModal,
    showModalWithData,
    closeModal,
  }
}
export default useModal
